import { apiConst, PAGE_LIMIT } from "@/lib/constant";
import { apiClient } from "@/lib/utils";
import { formCategoryUrl } from "@repo/lib/helpers";
import { getFeatureFlag } from "@repo/lib/utils";
import { notFound } from "next/navigation";

export async function getCategoryBySlug(
  slug,
  sortParam,
  pageNumber,
  filterParams,
  locale
) {
  const isCateogryCacheEnabled = getFeatureFlag("categoryCache");
  const url = formCategoryUrl(
    `${apiConst?.BASEURL}/${locale}/api/v1/category/term/${slug}?page=${pageNumber}&size=${PAGE_LIMIT}`,
    {
      sort: sortParam,
      filterParams,
    }
  );

  try {
    const response = await apiClient({
      path: url,
      cache: !isCateogryCacheEnabled ? "no-store" : "force-cache",
      skipAuth: true,
    });

    if (response.statusCode === 404) return notFound();
    return response;
  } catch (error) {
    console.log("error fetching category from getCategoryBySlug", error);
    return {
      error,
    };
  }
}

export async function getSubCategoryBySlug(slug, locale) {
  const url = formCategoryUrl(
    `${apiConst?.BASEURL}/${locale}/api/v1/category/${slug}/sub-category?type=setup&page=1&size=${PAGE_LIMIT}`
  );

  try {
    const response = await apiClient({
      path: url,
      cache: "no-store",
    });
    return response;
  } catch (error) {
    console.log("error fetching category from getSubCategoryBySlug", error);
    return {
      error,
    };
  }
}
